export default {
      id: "btn_cart-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite.svg#btn_cart",
      toString: function () {
        return this.url;
      }
    }